import React from "react";
export const Bracket = ({ teams }) => {
    const players5 = {
        round1: [[2, 3]],
        round2: [
          ["tbd", "tbd"],
          [5, 4]
        ],
        round3: [["tbd", "tbd"]]
      };
    
      const players15 = {
        round1: [
          [], // need to add this
          [734, 732],
          [731, 735],
          [736, 730],
        //   [733, 0],
        //   [7, 10],
        //   [3, 14],
        //   [6, 11]
        ],
        round2: [
          [1, "tbd"],
          ["tbd", "tbd"],
     
     
        ],
        round3: [
          ["tbd", "tbd"],
      
        ],
        round4: [["tbd", "tbd"]]
      };
      // Here I am settiing players Count
      const data = players15;
      const [lines, setLines] = React.useState([]);
      // Helper function to get player names or placeholders
      function getName(player) {
        if (!player) return "Player";
        if (player === "bye") return "Bye";
        if (player === "tbd") return "TBD";
        return `Player ${player}`;
      }
      let temp = [];
    
      const drawConnectorsBetweenMatches = (
        match1Selector,
        match2Selector,
        newLines
      ) => {
        const playoffTable = document.querySelector(".playoff-table");
        const { scrollLeft, offsetTop } = playoffTable;
        const { left: playoffTableLeft } = playoffTable.getBoundingClientRect();
    
        const match1Elem = document.getElementById(match1Selector);
        const match2Elem = document.getElementById(match2Selector);
          
        if (!match1Elem || !match2Elem) return;
    
        const match1Rect = match1Elem.getBoundingClientRect();
        const match2Rect = match2Elem.getBoundingClientRect();
    
        let midPointX =
          (match1Rect.right + match2Rect.left) / 2 + scrollLeft - playoffTableLeft;
    
        newLines.push({
          x1: midPointX,
          y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
          x2: midPointX,
          y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop
        });
        newLines.push({
          x1: match1Rect.right + scrollLeft - 20 - playoffTableLeft,
          y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
          x2: midPointX,
          y2: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop
        });
        newLines.push({
          x1: match2Rect.left + scrollLeft + 20 - playoffTableLeft,
          y1: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
          x2: midPointX,
          y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop
        });
      };
    
      React.useEffect(() => {
        const playoffTable = document.querySelector(".playoff-table");
        const linesOverlay = document.querySelector(".lines-overlay");
    
        const calculatePositions = () => {
          let newLines = [];
          // round 1 to 2
          drawConnectorsBetweenMatches(".round1match2", ".round2match1", newLines);
          drawConnectorsBetweenMatches(".round1match3", ".round2match2", newLines);
          drawConnectorsBetweenMatches(".round1match4", ".round2match2", newLines);
          drawConnectorsBetweenMatches(".round1match5", ".round2match3", newLines);
          drawConnectorsBetweenMatches(".round1match6", ".round2match3", newLines);
          drawConnectorsBetweenMatches(".round1match7", ".round2match4", newLines);
          drawConnectorsBetweenMatches(".round1match8", ".round2match4", newLines);
    
          // round 2 to 3
          drawConnectorsBetweenMatches(".round2match1", ".round3match1", newLines);
          drawConnectorsBetweenMatches(".round2match2", ".round3match1", newLines);
          drawConnectorsBetweenMatches(".round2match3", ".round3match2", newLines);
          drawConnectorsBetweenMatches(".round2match4", ".round3match2", newLines);
    
          // round 3 to 4
          drawConnectorsBetweenMatches(".round3match1", ".round4match1", newLines);
          drawConnectorsBetweenMatches(".round3match2", ".round4match1", newLines);
    
          setLines(newLines);
        };
    
        const handleScroll = () => {
          // When the playoff table is scrolled, adjust the left position of the lines overlay
          const { scrollLeft, scrollTop } = playoffTable;
          // Adjust the left position of the lines overlay
          linesOverlay.style.left = `-${scrollLeft}px`;
          // You can also adjust the top position if your table has vertical scrolling
          linesOverlay.style.top = `-${scrollTop}px`;
        };
        // playoffTable.addEventListener("scroll", handleScroll); // not sure why this is needed
    
        // Call the function after a delay to ensure DOM elements are rendered
        setTimeout(calculatePositions, 0);
    
        window.addEventListener("resize", calculatePositions);
    
        return () => {
          window.removeEventListener("resize", calculatePositions);
          playoffTable.removeEventListener("scroll", handleScroll);
        };
      }, []);
    

    
    return (
        <>
        <div className="playoff-table">
          <div className="playoff-table-content">
            {Object.keys(data).map((roundKey, roundIndex) => (
              <div key={roundKey} className="playoff-table-tour">
                {data[roundKey].map((pair, index) => {
                  return (
                    <div
                      key={index}
                      id={`.round${roundIndex + 1}match${index + 1}`}
                      className={`playoff-table-group round${
                        roundIndex + 1
                      }match${index + 1}`}
                    >
                      <div
                        key={index}
                        className={
                          "playoff-table-pair playoff-table-pair-style" +
                          (pair.length === 0 ? " playoff-table-pair--empty" : "")
                        }
                      >
                        <div className="playoff-table-left-player">
                          {getName(pair[0])}
                        </div>
                        <div className="playoff-table-right-player">
                          {getName(pair[1])}
                        </div>
                      </div>
                      {/* ))} */}
                    </div>
                  );
                })}
              </div>
            ))}
            <svg className="lines-overlay">
              {lines.map((line, index) => (
                <line
                  key={index}
                  x1={line.x1}
                  y1={line.y1}
                  x2={line.x2}
                  y2={line.y2}
                  stroke="black"
                />
              ))}
            </svg>
          </div>
        </div>
      </>
    );
}

export default Bracket;